var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
import { jsx, jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTheme } from "styled-components";
const AxisTicks = withTheme((_a = class extends Component {
  render() {
    const {
      orient,
      innerTickSize,
      tickPadding,
      scale,
      tickValues,
      tickArguments,
      tickFormatting,
      tickStroke,
      tickTextStroke,
      fontFamily,
      fontSize
    } = this.props;
    let tr;
    let ticks;
    let textAnchor;
    let tickFormat;
    let y1;
    let y2;
    let dy;
    let x1;
    let x2;
    const sign = orient === "top" || orient === "right" ? -1 : 1;
    const tickSpacing = Math.max(innerTickSize, 0) + tickPadding;
    if (tickValues) {
      ticks = tickValues;
    } else if (scale.ticks) {
      ticks = scale.ticks.apply(scale, tickArguments);
    } else {
      ticks = scale.domain();
    }
    if (tickFormatting) {
      tickFormat = tickFormatting;
    } else if (scale.tickFormat) {
      tickFormat = scale.tickFormat.apply(scale, tickArguments);
    } else {
      tickFormat = (d) => d;
    }
    const adjustedScale = scale.rangeBand ? (d) => scale(d) + scale.rangeBand() / 2 : scale;
    switch (orient) {
      case "top":
        tr = (tick) => `translate(${adjustedScale(tick)},0)`;
        textAnchor = "middle";
        y2 = innerTickSize * sign;
        y1 = tickSpacing * sign;
        dy = sign < 0 ? "0em" : ".71em";
        break;
      case "bottom":
        tr = (tick) => `translate(${adjustedScale(tick)},0)`;
        textAnchor = "middle";
        y2 = innerTickSize * sign;
        y1 = tickSpacing * sign;
        dy = sign < 0 ? "0em" : ".71em";
        break;
      case "left":
        tr = (tick) => `translate(0,${adjustedScale(tick)})`;
        textAnchor = "end";
        x2 = innerTickSize * -sign;
        x1 = tickSpacing * -sign;
        dy = ".32em";
        break;
      case "right":
        tr = (tick) => `translate(0,${adjustedScale(tick)})`;
        textAnchor = "start";
        x2 = innerTickSize * -sign;
        x1 = tickSpacing * -sign;
        dy = ".32em";
        break;
    }
    return /* @__PURE__ */ jsx("g", { children: ticks.map((tick, idx) => /* @__PURE__ */ jsxs("g", { className: "tick", transform: tr(tick), children: [
      /* @__PURE__ */ jsx("line", { style: {
        shapeRendering: "crispEdges",
        opacity: "1",
        stroke: tickStroke
      }, x2, y2 }),
      /* @__PURE__ */ jsx("text", { strokeWidth: "0.01", dy, x: x1, y: y1, style: {
        stroke: tickTextStroke,
        fill: tickTextStroke,
        fontFamily,
        fontSize
      }, textAnchor, children: tickFormat(tick) })
    ] }, idx)) });
  }
}, __publicField(_a, "displayName", "AxisTicks"), __publicField(_a, "propTypes", {
  scale: PropTypes.func.isRequired,
  orient: PropTypes.oneOf(["top", "bottom", "left", "right"]).isRequired,
  tickArguments: PropTypes.array,
  tickValues: PropTypes.array,
  innerTickSize: PropTypes.number,
  outerTickSize: PropTypes.number,
  tickPadding: PropTypes.number,
  tickFormat: PropTypes.func,
  tickStroke: PropTypes.string,
  tickTextStroke: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.string,
  // To simply satisfy eslint
  tickFormatting: PropTypes.any
}), __publicField(_a, "defaultProps", {
  innerTickSize: 6,
  outerTickSize: 6,
  tickPadding: 3,
  tickArguments: [10],
  tickValues: null,
  fontSize: "10px"
}), _a));
export {
  AxisTicks as default
};
